module.exports = __webpack_public_path__ + "img/excellence.36a2b31.webp";